import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class EmailSubService {
  constructor(private afs: AngularFirestore) {}

  public addEmailToSubscription(emailId: string): Promise<any> {
    return this.afs.collection(`subscription`).add({
      email: emailId,
    });
  }
}
